import * as React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import stylesheet, { blue } from './constants/stylesheet';
import 'minireset.css';
import { Api } from './@context/Api';
import Header from './Components/Header';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Pages from './Components/Pages';
import { ResponsiveProvider } from './@context/Responsive';
import mediaQueries from './constants/responsive';
import fonts from './constants/fonts';

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      'html, body': {
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        ...stylesheet.Body,
      },
      'a': {
        textDecoration: 'none',
        color: 'inherit',
        cursor: 'pointer',

        '&:hover': {},
      },
      '#root': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        top: 0,
        left: 0,
        background: 'white'
      },
      'p a': {
        ...stylesheet.Bold,
        textDecoration: 'none',
        color: 'inherit',
        cursor: 'pointer',
        backgroundImage: `linear-gradient(to bottom,rgba(0,0,0,0) 50%,${blue} 50%)`,
        backgroundRepeat: 'repeat-x',
        backgroundSize: '2px 2px',
        backgroundPosition: '0 1em',
        display: 'inline-block',

        '&:hover': {
          backgroundImage: `none`,
        },
      },
      'em': {},
      'img': {
        display: 'block'
      },
      'button': {
        padding: 0,
        margin: 0,
        backgroundColor: 'transparent',
        border: 'none',
        pointer: 'cursor',
        '&:focus': {
          outline: 'none'
        }
      },
      '.custom-style-h1': {
        ...stylesheet.TitleH1
      },
      '.custom-style-h2': {
        ...stylesheet.TitleH2
      },
      '.custom-style-h3': {
        ...stylesheet.TitleH3
      },
      '.custom-style-credits': {
        ...stylesheet.Credits
      },
      '.custom-style-menu': {
        ...fonts.Condensed,
        color: blue,
        lineHeight: '1.2',
        fontSize: '.933rem',
        textTransform: 'uppercase',
        letterSpacing: '1px',
      },
      '.custom-style-intro': {
        ...stylesheet.Intro
      },
      '.list': {
        paddingLeft: 20
      },
      'svg': {
        width: '100%',
      },
      'hr': {
        ...stylesheet.HR
      },
      'table': {
        width: '100%',
        border: 1,
        borderStyle: 'solid',
        borderColor: '#0064b4',
        backgroundColor: 'white',
        marginLeft: 'auto',
        marginRight: 'auto',
      },
      'td': {
        verticalAlign: 'top',
        padding: 5
      },
    },
    app: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      overflow: 'auto',
      '-webkit-overflow-scrolling': 'touch',
      fontSize: '1rem',
      zIndex: 0
    },
  }));

const App: React.FC = () => {
  const cls = useStyles();

  return (
    <Router>

      <ResponsiveProvider mediaQueries={mediaQueries}>
        <Api>
          <div id={'scrollContainer'} className={cls.app}>
            <Header />
            <Switch>
              {
                // tslint:disable-next-line:jsx-no-lambda
                <Route render={() => <Pages />} />
              }
            </Switch>
          </div>
        </Api>
      </ResponsiveProvider>
    </Router>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx